import React, {useEffect, useState} from 'react';

import moment from 'moment';
import {readCookie} from "../helper";

function ActivityDropdown (props) {

    const [activities, setActivities] = useState([]);

    const [value, setValue] = useState(0);

    useEffect(() => {

        window.strava.get(`/athlete/activities?before=${moment(props.segment.end_date).format('X')}&after=${moment(props.segment.start_date).format('X')}`)
            .then(response => setActivities(response.data.filter(activity => activity.type === 'Ride')))

    }, []);

    const handleSubmit = (event) => {

        event.preventDefault();

        axios.post(`/api/segments/${props.segment.id}/activity`, {
            'activity_id': value,
            'token': readCookie('access_token'),
        })
            .then(response => {

                switch (response.status) {
                    case 200:
                        alert('Deine Fahrt wurde eingetragen!')
                        break;
                    case 204:
                        alert('Dein bisheriger Eintrag wurde aktualisiert!')
                        break;
                    default:
                        alert('ok')
                        break;

                }

                window.location.reload();

            })
            .catch(error => {

                if (error.response) alert(error.response.data.message);

            })

        return;

    }

    return (

        <form onSubmit={handleSubmit}>
            <label>

                <select name="cars" id="cars" value={value} onChange={(event) => setValue(event.target.value)}>

                    <option value="0" disabled>Aktivität auswählen</option>

                    {activities.map((activity) => (

                        <option value={activity.id} key={activity.id}>{activity.name} / {moment(activity.start_date).calendar()}</option>

                    ))}
                </select>
            </label>
            <input type="submit" value="Eintragen" />
        </form>

    )

}

export default ActivityDropdown
